// Applies the hardcoded display prices from snippets/ll-fixed-price.liquid to product cards
// rendered client-side by Boost AI Search & Discovery (filtered collections, search results).
// Boost re-renders its grid on every filter/sort/page change, so we watch the DOM and re-apply.
(function () {
  const prices = window.llFixedPrices || {};
  if (!Object.keys(prices).length) return;

  // Swap the number inside Boost's formatted price (e.g. "$845" -> "$995"),
  // keeping Boost's currency symbol and its choice to show or hide decimals.
  function replaceAmount(text, cents) {
    const showDecimals = /\d[.,]\d{2}(?!\d)/.test(text);
    const amount = (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: showDecimals ? 2 : 0,
      maximumFractionDigits: showDecimals ? 2 : 0,
    });
    return text.replace(/\d[\d,.]*/, amount);
  }

  function applyFixedPrices() {
    document.querySelectorAll('.boost-sd__product-item[data-product-id]').forEach((item) => {
      const cents = prices[item.dataset.productId];
      if (cents == null) return;

      item.querySelectorAll('.boost-sd__product-price .boost-sd__format-currency').forEach((el) => {
        if (el.closest('[class*="compare"]')) return;
        const text = replaceAmount(el.textContent, cents);
        if (el.textContent !== text) el.textContent = text;
      });

      item.querySelectorAll('.boost-sd__product-price-wrapper[aria-label]').forEach((el) => {
        const label = replaceAmount(el.getAttribute('aria-label'), cents);
        if (el.getAttribute('aria-label') !== label) el.setAttribute('aria-label', label);
      });
    });
  }

  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyFixedPrices();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  applyFixedPrices();
})();
